import React from 'react'
import { Box, PageContainerMain } from '../../../Components/Layout'
import { useSingleVideoUrlParams } from '../../../Context/utils'
import { FullVideoCon } from './components/FullVideoCon'
import { colors } from '../../../Components/consts'

const SingleVideo: React.FC<React.PropsWithChildren<unknown>> = () => {
  const vidUrlObj = useSingleVideoUrlParams()

  return (
    <>
      <PageContainerMain backgroundColor={colors.darkBackground}>
        <Box noMargin boxColor={colors.black}>
          {vidUrlObj?.mediaId && <FullVideoCon mediaId={vidUrlObj?.mediaId} />}
        </Box>
      </PageContainerMain>
    </>
  )
}

export default SingleVideo